import { Phone, Mail, Send } from "lucide-react";

const NoDataFound = ({
  title = "Tour Details Coming Soon",
  description = "We're currently updating the details for this experience. Please check back shortly, or contact us for more information.",
  phone = "+91 9876543210",
  email = "support@gosehari.com",
}) => {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl rounded-3xl border border-gray-200 bg-white p-8 md:p-12 text-center shadow-xl">

        <div className="mb-6 text-6xl">🏝️</div>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
          {title}
        </h1>

        <p className="mt-4 text-gray-600 leading-7">
          {description}
        </p>

        <div className="mt-8 rounded-2xl bg-gray-50 p-6">
          <h3 className="mb-4 text-lg font-semibold text-gray-900">
            Need Assistance?
          </h3>

          <div className="space-y-3 text-left">

            <a
              href={`tel:${phone.replace(/\s/g, "")}`}
              className="flex items-center gap-3 text-gray-700 hover:text-red-600"
            >
              <Phone size={18} />
              <span>{phone}</span>
            </a>

            <a
              href={`mailto:${email}`}
              className="flex items-center gap-3 text-gray-700 hover:text-red-600"
            >
              <Mail size={18} />
              <span>{email}</span>
            </a>

          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">

          <a
            href={`tel:${phone.replace(/\s/g, "")}`}
            className="rounded-full bg-red-600 px-6 py-3 font-semibold text-white transition hover:bg-red-700"
          >
            Call Now
          </a>

          <a
            href="/contact"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-red-600 px-6 py-3 font-semibold text-red-600 transition hover:bg-red-50"
          >
            <Send size={18} />
            Send Enquiry
          </a>

        </div>
      </div>
    </div>
  );
};

export default NoDataFound;